import React from "react";

const Comet = () => {
    return (
        <div
            style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                pointerEvents: "none",
            }}
        >
            <div
                style={{
                    width: "10px",
                    height: "10px",
                    background: "rgba(255, 255, 255, 0.7)",
                    borderRadius: "50%",
                    boxShadow: "0 0 20px 10px rgba(255, 255, 255, 0.5)",
                    animation: `cometTail 1s linear infinite`,
                    transformOrigin: "center",
                    position: "absolute",
                }}
            />
            <style>{`
        @keyframes cometTail {
          0% {
            transform: rotate(0deg) translate(90px) rotate(0deg);
          }
          100% {
            transform: rotate(360deg) translate(90px) rotate(-360deg);
          }
        }
      `}</style>
        </div>
    );
};

export default Comet;
